const featureFlags = {
  showActivityFeed: false,
  showWorkboard: false,
  showReleases: false,
  showHomePage: false
};

export default featureFlags;
